import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion,getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";
// import Image from "react-bootstrap/Image";

class ResearchAreas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id:props.id,
			lineasInv: props.lineasInv,
            currentPagelineasInv:1,
            loadinglineasInv:true,
            lineasInvActuales:[],
            itemPerPage:props.item
            
		};
        
      }
    render(){
        const windowWidth = window.innerWidth;
		const isDesktop = windowWidth > 600;
        return(	
        <div>
        <div>

        {this.setState({lineasInvActuales:this.state.lineasInv.slice((this.state.currentPagelineasInv - 1) * this.state.itemPerPage, this.state.currentPagelineasInv * this.state.itemPerPage),loadinglineasInv:false})}

        {this.state.loadinglineasInv ? <Spinner /> :
            this.state.lineasInvActuales.map((
                {title, description, image, detailedDescription})=>{		
            return(					
                <div className='lineaInv-card alt' >
						<div class="meta">
							<div className="photo"><img src={image} width='100%' height='200px' alt={title}/></div>
						</div>
						<div class="description">
							<h1>{title}</h1>
							<p>{detailedDescription}</p>
						</div>
                        {!isDesktop ? <hr/> : null}
				</div>
            );
        
         })}
        </div>
        <Paginacion id={this.state.id} itemPerPage ={this.state.itemPerPage} length={this.state.lineasInv.length}/>
        {this.setState({currentPagelineasInv:getCurrentPage(this.state.id)})}
        </div>
        );
        
    }
}

 export default ResearchAreas;